// #ux-redesign-start: AnalytesGroupsService
// Service para resolver el Grupo activo + classifications del catálogo
// para los analitos de un estudio. Ver .ia/32-analytes-catalog.md.
//
// El response del backend NO incluye labels — sólo `key + order + is_fallback`.
// Las labels se resuelven en el cliente con `useTranslate('analytes-groups')`.
// Fallback de locale: alemán (lo maneja react-translate automáticamente si
// hay missing key, sino el namespace lo cubre completo).
// ─────────────────────────────────────────────────────────────────────────────

import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

const DEFAULT_GROUP_KEY = 'clinical-standard';

class AnalytesGroupsService extends AxiosService {
  constructor() {
    super('aspect-doctor-user');
  }

  /**
   * Devuelve { group: { key, classifiers: [...] }, classifications: { id: key } }
   * `identifiers` es la lista de OBX-3 flat de los analitos del estudio.
   */
  resolve = async (identifiers, groupKey = DEFAULT_GROUP_KEY) => {
    const response = await this.post(
      `/analytes-groups/${encodeURIComponent(groupKey)}/resolve`,
      { identifiers },
      {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          'content-type': 'application/json',
        },
      },
    );
    return response;
  };

  getGroup = async (groupKey = DEFAULT_GROUP_KEY) => {
    const response = await this.get(`/analytes-groups/${encodeURIComponent(groupKey)}`, {
      headers: { Authorization: `Bearer ${this.getToken()}` },
    });
    return response;
  };

  // Lista los Grupos disponibles (metadata solo). Para popular dropdown.
  list = async () => {
    const response = await this.get(`/analytes-groups/`, {
      headers: { Authorization: `Bearer ${this.getToken()}` },
    });
    return response;
  };
}

export { DEFAULT_GROUP_KEY };
export default new AnalytesGroupsService();
// #ux-redesign-end
